<template>
    <div class="app_container">
        <img src="../../../assets/image/jiaxing/2.png" alt />
    </div>
</template>

<script>
  export default {
    name: "index"
  };
</script>

<style scoped>

</style>
